/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import template from './custom-merchandise.stache';
import 'components/custom-merchandise/custom-merchandise';

export const CustomMerchandise = BaseControl.extend({
    init: function () {
        this._super();
        this.$element
            .find('.s-right-rail-container__content')
            .prepend(template({products: this.options.products, productsCtaLink: this.options.productsCtaLink}));
    }
});
